module.exports = __webpack_public_path__ + "img/under.be5030ca.webp";